<template>
    <div
        class="c-form__item is-required"
        :class="{[`c-form__item--${type}`]: true, 'is-disabled': disabled}"
    >
        <label
            class="c-form__label"
            :for="name"
        >
            {{ label }}:
        </label>

        <input
            ref="input"
            required
            :type="type"
            :name="name"
            class="c-form__input"
            :class="[inputClass, { 'error': error, 'valid': isValid }]"
            :placeholder="placeholder || label"
            :id="name"
            :value="value"
            :disabled="disabled"
            @input="$emit('input', $event.target.value)"
            @blur="validate"
            @keyup="validate"
        >

        <label class="error" v-if="error">
            {{ error }}
        </label>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: false
        },
        type: {
            type: String,
            default: 'text'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        inputClass: {
            type: String,
            default: ''
        },
        value: String,
    },
    data() {
        return {
            error: null,
            smartformError: null,
            isValid: false
        }
    },
    mounted() {
        // Listen for SmartForm validation events using bound handlers
        this.boundPhoneHandler = (event) => this.onSmartformPhoneValidated(event);
        this.boundEmailHandler = (event) => this.onSmartformEmailValidated(event);

        if (this.inputClass && this.inputClass.includes('smartform-phone-number')) {
            this.$refs.input.addEventListener('smartform-phone-validated', this.boundPhoneHandler);
        }
        if (this.inputClass && this.inputClass.includes('smartform-email')) {
            this.$refs.input.addEventListener('smartform-email-validated', this.boundEmailHandler);
        }
    },
    beforeDestroy() {
        // Clean up event listeners
        if (this.$refs.input) {
            this.$refs.input.removeEventListener('smartform-phone-validated', this.boundPhoneHandler);
            this.$refs.input.removeEventListener('smartform-email-validated', this.boundEmailHandler);
        }
    },
    methods: {
        validate() {
            this.error = null;
            this.isValid = false;

            if (!this.value) {
                this.error = this.$t('Switch.Form.Errors.required');
                return;
            }

            if (this.smartformError) {
                this.error = this.smartformError;
                return;
            }

            // All validations passed
            this.isValid = true;
        },
        onSmartformPhoneValidated(event) {
            if (event.detail.valid) {
                this.smartformError = null;
            } else {
                this.smartformError = event.detail.response?.result?.message || 'Neplatné telefónne číslo.';
            }
            this.validate();
        },
        onSmartformEmailValidated(event) {
            if (event.detail.valid) {
                this.smartformError = null;
            } else {
                this.smartformError = event.detail.response?.result?.message || 'Neplatná e-mailová adresa.';
            }
            this.validate();
        }
    }
}
</script>